import { useTranslation } from 'react-i18next';
import { Icon, Text } from '@shared/widgets';
import PlusIcon from '@assets/icons/plus.svg';

interface AddInReportsProps {
  showModal: () => void;
}

export function AddInReports(props: AddInReportsProps) {
  const { t } = useTranslation();

  return (
    <div className='flex cursor-pointer items-center' onClick={props.showModal}>
      <div className='mr-1 flex h-4 w-4 items-center justify-center opacity-60'>
        <Icon icon={<PlusIcon />} className='scale-75' />
      </div>
      <Text className='underline transition-opacity duration-200 hover:opacity-100'>{t('buttons.add')}</Text>
    </div>
  );
}
